<template>
  <div class="class">

    <div class="teacher_info" v-if="data">
      <div class="tit">基本介绍</div>
      <div class="box">
        <img :src="data.teacher.teacher_image" alt="">
        <div class="info">
          <div class="tname">讲师：{{data.teacher.teacher_name}}</div>
          <div class="tdesc">{{data.teacher.teacher_desc}}</div>
        </div>
      </div>
    </div>

    <div class="list">
      <div class="hot_course_list" v-if="data">
        <div class="tit">
          <span class="t1">{{data.course.course_name}}</span>
          <span class="t2">{{data.course.course_other_name}}</span>
        </div>

        <el-carousel height="590px" :autoplay="false" :loop="false" >
          <el-carousel-item v-for="item in data.f_lesson" :key="item.id">
            <div class='item' v-for="sub in item" :key="sub.id">
            
              <div class="tit_name">
                <span class="f1">{{sub.lesson_name}}</span>
                <span class="f2">{{sub.lesson_short_desc}}</span>
              </div>
              <div class="tit_info">
                <div class="imgbox" @click="onLook(sub.course_id, sub.id)">
                  <img :src="sub.lesson_image" alt="" >
                  <div class="playBtn">
                    <a href="#" title="start">start</a>
                  </div>
                </div>
                <div class="info">
                  <div class="l l1"><i class="el-icon-view"></i>总观看数 <span>{{sub.view_count > 100000 ? sub.view_count+'W+' : sub.view_count}}</span> </div>
                  <div class="l l2"><i class="el-icon-time"></i>总观时长 <span>{{sub.view_times_total > 100000 ? sub.view_times_total+'W+' : sub.view_times_total}}</span> </div>
                  <div class="l l3"><i class="el-icon-user"></i>科目学员数 <span>{{sub.view_member_count > 100000 ? sub.view_member_count+'W+' : sub.view_member_count}}</span> </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>

      </div>
    </div>

    <div class="course_info" v-if="data">
      <div class="tit">课程简介</div>
      <div class="info">{{data.course.course_desc}}</div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'class',
  data:function () {
    return {
      data:null
    }
  },
  created(){
    console.log("class created")
    this.fetch();
  },
  watch: {
		// '$route' (to, from) {
    '$route' () {
      // console.log("route :",to,from,this.$route);
      this.fetch();
		}
	},
  methods:{
   async fetch(){
    let res = await this.$fly.get('/course/courseDetail',{course_id: this.$route.params.id});

    //测试
    // for (let i = 0; i < 20; i++) {
    //   res.lesson.push(res.lesson[0])
    // }
    //课程
    res.f_lesson = [];
    for (let i = 0; i < res.lesson.length; i++) {
      let f = parseInt(i/9);
      
      if (res.f_lesson[f]){
        res.f_lesson[f].push(res.lesson[i]);
      }else{
        res.f_lesson[f] = [];
        res.f_lesson[f].push(res.lesson[i]);
      }
    }

    this.data = res;
    this.$store.state.bannerlist = this.data.course.banners;
    console.log("this.data:",this.data);
     
   },
   onLook(course_id,course_lesson_id){
    console.log("播放的课程id:",course_id,", 章节id:",course_lesson_id);
    
    this.$router.push({ name: 'Look', params: { id: course_id, course_lesson_id:course_lesson_id}})
  },
  }
}
</script>

<style lang='scss'>

.class{

  .teacher_info{
    width: 1024px;
    margin: 40px auto;
    .tit{
      font-size: 20px;
      color: #585959;
      border-bottom: 1px solid #979797;
      padding-bottom: 20px;
    }
    .box{
      display: flex;
      margin-top: 20px;

      img{
        width: 198px;
        height: 262px;
        border-radius: 5px;
      }

      .info{
        width: 820px;
        margin-left: 20px;
        .tname{
          font-size: 20px;
          color: #585959;
        }
        .tdesc{
          font-size: 14px;
          color: #585959;
          margin-top: 20px;
          text-indent: 29px;
        }
      }

    }
  }

  .course_info{
    width: 1024px;
    margin: 40px auto;
    .tit{
      font-size: 20px;
      color: #585959;
      border-bottom: 1px solid #979797;
      padding-bottom: 20px;
    }
    .info{
      font-size: 14px;
      color: #585959;
      margin-top: 20px;
      text-indent: 29px;
    }
  }

  .list{
    background-color: #EFEEEE;
    padding: 30px 0;
  }

  .hot_course_list{
    width:1024px;
    margin: 30px auto 0;
   
    .tit{
      background-color:#fff;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      padding:10px 14px;
      border-radius: 5px;
      display:flex;
      align-items:baseline;

      .t1{
        font-size: 20px;
        color: #00B3A4;
      }

      .t2{
        font-size: 16px;
        color: #B3B3B3;
        margin-left:20px;
      }
    }

    .el-carousel{
      margin-top:20px;
    }

    .el-carousel__arrow{
      display: none;
    }

    .el-carousel__button{
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: #CCC;
    }

    .is-active button {
      background-color: #999;
      width: 40px;
      
    }
  }

  .item:nth-child(3n) {
     margin-right: 0;
  }

  .item{
    width:306px;
    height:146px;
    background-color:#fff;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    padding:10px 0;
    border-radius: 5px;
    text-align: left;
    margin-right: 52px;
    display: inline-block;
    margin-bottom: 20px;

    .tit_name{
      display:flex;
      align-items:center;

      .f1{
        width:25%;
        height:35px;
        line-height:35px;
        background-color:#00B3A4;
        color:#fff;
        font-size:16px;
        overflow:hidden;
        padding: 0 6px;
        font-weight: bold;
      }

      .f2{
        width:60%;
        height:35px;
        line-height:35px;
        color:#000;
        font-size:16px;
        overflow:hidden;
        margin-left:6px;
      }

    }

    .tit_info{
      display:flex;
      align-items:center;

      .imgbox{
        width:158px;
        height:106px;
        margin-top: 6px;
        margin-left: 6px;
        cursor: pointer;
        position: relative;

        img{
          width:158px;
          height:106px;
        }

        .playBtn{ 
          position: absolute; 
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          height: 50px; 
          width:50px; 
          -webkit-border-radius: 100%; 
          -moz-border-radius: 100%; 
          -o-border-radius: 100%; 
          border-radius: 100%; 
          margin: auto; 
          background-color: rgba(115, 133, 159, 0.5);
          border: 2px solid #fff; 

          a { 
            border-color: transparent transparent transparent #fff; 
            border-width: 8px 0 8px 12px;  
            width: 0; height: 0; 
            border-style: solid;
            text-indent: -9999px; 
            position: absolute; 
            top: 16px;
            left: 21px; 
          }
        }

      }

      .info{
        font-size:12px;
        color: #808080;
        margin-left:8px;
        width:130px;

        .l{
          display:flex;
          align-items:center;
          margin: 6px 0;

          i{
            color:#00B3A4;
            margin-right:8px;
          }

          span{
            margin-left:8px;
          }
        }
        
      }
    }
  }
  
}

</style>